import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component( {
    // tslint:disable-next-line:component-selector
    selector: 'ridango-selectable-list',
    templateUrl: './selectable-list.component.html',
    styleUrls: [ './selectable-list.component.scss' ]
} )
export class SelectableListComponent implements OnInit, OnChanges {

    @Input() items: any[];

    @Input() selectedItem: any;

    @Input() labelledBy: string;

    @Input() listBoxId: string;

    @Input() listItemIdPrefix: string;

    @Input() selectedIndex: number;

    @Input() rclass: string;

    @Output() onItemSelected: EventEmitter<any> = new EventEmitter();

    @ViewChild( 'autocompleteOptions', { static: true } ) optionsList: ElementRef;

    localSelectedItem: any;

    constructor() {
    }

    ngOnInit () {
    }


    ngOnChanges ( changes: SimpleChanges ) {
        if ( changes.selectedIndex && changes.selectedIndex.currentValue >= 0 ) {
            const elem = this.optionsList.nativeElement.children[ changes[ 'selectedIndex' ].currentValue ];
            this.selectedIndex = changes[ 'selectedIndex' ].currentValue;
            if ( elem ) {
                // tslint:disable-next-line:max-line-length
                this.optionsList.nativeElement.scrollTop = this.optionsList.nativeElement.children[ changes[ 'selectedIndex' ].currentValue ].offsetTop;
            } else {
                this.optionsList.nativeElement.scrollTop = 0;
            }
        } else {
            // this.selectedIndex = -1;
            this.selectedItem = null;
            this.optionsList.nativeElement.scrollTop = 0;
        }
        if ( changes[ 'selectedItem' ] && changes[ 'selectedItem' ].currentValue ) {
            if ( changes[ 'selectedItem' ].currentValue !== this.localSelectedItem ) {
                this.itemSelected( changes[ 'selectedItem' ].currentValue );
            }
        }


    }

    itemSelected ( item ) {
        if ( this.items ) {
            this.localSelectedItem = item;
            this.selectedIndex = this.items.findIndex( i => i === item );
            this.optionsList.nativeElement.scrollTop = 0;
            this.onItemSelected.emit( item );
        }
    }
}
